import React from "react";
import * as Components from "../../components/all";
import img1 from "../../assets/person1.png";
import img2 from "../../assets/person2.png";
import img3 from "../../assets/person3.png";
import img4 from "../../assets/person4.png";

export default function AdminZoom() {
	return (
		<div className="AdminProfile bg-[#F7F9FF] flex items-stretch h-screen max-h-screen overflow-hidden">
			{/* Sidebar */}
			<Components.Sidebar page={"zoom"} />

			{/* Right */}
			<div className="flex-1 flex flex-col items-stretch overflow-hidden">
				{/* Navbar */}
				<Components.AdminNavbar page={"Zoom Session"} />
				{/* Page */}
				<div className="p-4 flex-1 h-full overflow-auto text-start">
					{/* heading */}
					<Components.Paragraph className="font-bold mt-5">
						Participants (6)
					</Components.Paragraph>

					{/* cards */}
					<div className="flex justify-center items-center mt-3 px-5">
						<div className="relative h-24 w-32 bg-gray-200 rounded overflow-hidden mx-2">
							<img
								loading="lazy"
								src={img1}
								alt="img1"
								className="h-full w-full"
							/>

							<p className="absolute bottom-0 left-0 text-white bg-[#C33B4C] bg-opacity-80 px-4 text-xs">
								David
							</p>
						</div>

						<div className="relative h-24 w-32 bg-gray-200 rounded overflow-hidden mx-2">
							<img
								loading="lazy"
								src={img2}
								alt="img1"
								className="h-full w-full"
							/>

							<p className="absolute bottom-0 left-0 text-white bg-[#C33B4C] bg-opacity-80 px-4 text-xs">
								Aliya
							</p>

							<svg
								className="absolute top-0 left-0 m-2"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M11.2598 3.6912C11.479 3.78209 11.6664 3.93594 11.7982 4.13331C11.9299 4.33067 12.0003 4.56268 12.0002 4.8V19.2C12.0001 19.4373 11.9297 19.6693 11.7979 19.8665C11.666 20.0638 11.4786 20.2176 11.2594 20.3084C11.0401 20.3992 10.7989 20.423 10.5662 20.3767C10.3334 20.3304 10.1196 20.2162 9.95179 20.0484L5.5034 15.6H2.4002C2.08194 15.6 1.77671 15.4736 1.55167 15.2485C1.32662 15.0235 1.2002 14.7183 1.2002 14.4V9.6C1.2002 9.28174 1.32662 8.97651 1.55167 8.75147C1.77671 8.52642 2.08194 8.4 2.4002 8.4H5.5034L9.95179 3.9516C10.1196 3.78368 10.3335 3.66931 10.5663 3.62295C10.7991 3.5766 11.0405 3.60035 11.2598 3.6912ZM17.5886 3.5148C17.8136 3.28983 18.1188 3.16345 18.437 3.16345C18.7552 3.16345 19.0604 3.28983 19.2854 3.5148C20.4011 4.62802 21.286 5.95067 21.8892 7.4068C22.4923 8.86294 22.8019 10.4239 22.8002 12C22.8019 13.5761 22.4923 15.1371 21.8892 16.5932C21.286 18.0493 20.4011 19.372 19.2854 20.4852C19.0591 20.7038 18.7559 20.8247 18.4413 20.822C18.1267 20.8193 17.8257 20.6931 17.6032 20.4706C17.3807 20.2481 17.2545 19.9471 17.2518 19.6325C17.2491 19.3178 17.37 19.0147 17.5886 18.7884C18.4816 17.8981 19.1897 16.84 19.6722 15.6749C20.1547 14.5099 20.4021 13.261 20.4002 12C20.4022 10.739 20.1548 9.49005 19.6723 8.32502C19.1898 7.15999 18.4816 6.10189 17.5886 5.2116C17.3636 4.98656 17.2373 4.68139 17.2373 4.3632C17.2373 4.045 17.3636 3.73983 17.5886 3.5148ZM14.1938 6.9084C14.3052 6.79682 14.4376 6.70831 14.5833 6.64792C14.7289 6.58753 14.8851 6.55645 15.0428 6.55645C15.2005 6.55645 15.3566 6.58753 15.5023 6.64792C15.648 6.70831 15.7803 6.79682 15.8918 6.9084C16.5613 7.57635 17.0922 8.37003 17.4541 9.24381C17.8159 10.1176 18.0015 11.0543 18.0002 12C18.0015 12.9457 17.8159 13.8824 17.4541 14.7562C17.0922 15.63 16.5613 16.4236 15.8918 17.0916C15.6666 17.3168 15.3612 17.4433 15.0428 17.4433C14.7244 17.4433 14.419 17.3168 14.1938 17.0916C13.9686 16.8664 13.8421 16.561 13.8421 16.2426C13.8421 15.9242 13.9686 15.6188 14.1938 15.3936C14.6403 14.9486 14.9945 14.4196 15.2359 13.8372C15.4772 13.2548 15.601 12.6304 15.6002 12C15.6012 11.3695 15.4775 10.7451 15.2361 10.1626C14.9948 9.58021 14.6405 9.0513 14.1938 8.6064C13.9688 8.38116 13.8423 8.07579 13.8423 7.7574C13.8423 7.439 13.9688 7.13363 14.1938 6.9084Z"
									fill="#3D5EE1"
								/>
							</svg>
						</div>

						<div className="relative h-24 w-32 bg-gray-200 rounded overflow-hidden mx-2">
							<img
								loading="lazy"
								src={img3}
								alt="img1"
								className="h-full w-full"
							/>

							<p className="absolute bottom-0 left-0 text-white bg-[#C33B4C] bg-opacity-80 px-4 text-xs">
								Aliya
							</p>
						</div>

						<div className="relative h-24 w-32 bg-gray-200 rounded overflow-hidden mx-2">
							<img
								loading="lazy"
								src={img1}
								alt="img1"
								className="h-full w-full"
							/>

							<p className="absolute bottom-0 left-0 text-white bg-[#C33B4C] bg-opacity-80 px-4 text-xs">
								Jack
							</p>
						</div>

						<div className="relative h-24 w-32 bg-gray-200 rounded overflow-hidden mx-2">
							<img
								loading="lazy"
								src={img1}
								alt="img1"
								className="h-full w-full"
							/>

							<p className="absolute bottom-0 left-0 text-white bg-[#C33B4C] bg-opacity-80 px-4 text-xs">
								Jack
							</p>
						</div>

						<div className="relative h-24 w-32 bg-gray-200 rounded overflow-hidden mx-2">
							<img
								loading="lazy"
								src={img1}
								alt="img1"
								className="h-full w-full"
							/>

							<p className="absolute bottom-0 left-0 text-white bg-[#C33B4C] bg-opacity-80 px-4 text-xs">
								David
							</p>
						</div>
					</div>

					{/* large card */}
					<div className="flex items-center justify-between mt-8">
						{/* you */}
						<div className="flex items-center">
							<svg
								width="20"
								height="20"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M14.7036 5.88215C14.7036 5.54305 14.5092 5.23397 14.2036 5.08707C13.898 4.94018 13.5352 4.98148 13.2704 5.19331L9.10129 8.52859H5.88215C5.39495 8.52859 5 8.92354 5 9.41074V14.7036C5 15.1908 5.39495 15.5858 5.88215 15.5858H9.10129L13.2704 18.921C13.5352 19.1329 13.898 19.1742 14.2036 19.0273C14.5092 18.8804 14.7036 18.5713 14.7036 18.2322V5.88215ZM9.9618 10.0996L12.9393 7.71757V16.3968L9.9618 14.0148C9.80539 13.8896 9.61104 13.8215 9.41073 13.8215H6.76429V10.2929H9.41073C9.61104 10.2929 9.80539 10.2247 9.9618 10.0996Z"
									fill="#555F61"
								/>
								<path
									d="M18.4503 8.31066C18.1059 7.96611 17.5473 7.96603 17.2028 8.31048C16.8582 8.65492 16.8581 9.21347 17.2026 9.55802C17.8641 10.2197 18.2357 11.1171 18.2357 12.0527C18.2357 12.9884 17.8641 13.8857 17.2026 14.5474C16.8581 14.892 16.8582 15.4505 17.2028 15.795C17.5473 16.1394 18.1059 16.1393 18.4503 15.7948C19.4426 14.8022 20 13.4562 20 12.0527C20 10.6492 19.4426 9.30323 18.4503 8.31066Z"
									fill="#555F61"
								/>
							</svg>
							<p className="text-xs text-[#555F61]">Joyaba (You)</p>
						</div>
						{/* button */}
						<button className="text-white flex items-center bg-[#F38315] py-1 px-4 rounded-full mr-28">
							<svg
								width="32"
								height="32"
								viewBox="0 0 32 32"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M15.9889 27.4531C22.2643 27.4531 27.444 22.2734 27.444 16.0091C27.444 9.7448 22.2533 4.56511 15.9779 4.56511C9.71354 4.56511 4.54492 9.7448 4.54492 16.0091C4.54492 22.2734 9.72461 27.4531 15.9889 27.4531ZM15.9889 25.1732C10.9089 25.1732 6.84701 21.0892 6.84701 16.0091C6.84701 10.929 10.9089 6.85612 15.9779 6.85612C21.0579 6.85612 25.1419 10.929 25.153 16.0091C25.1641 21.0892 21.069 25.1732 15.9889 25.1732ZM16 20.3477C18.4017 20.3477 20.3385 18.4108 20.3385 15.9981C20.3385 13.6074 18.4017 11.6595 16 11.6595C13.5872 11.6595 11.6504 13.6074 11.6504 15.9981C11.6504 18.4108 13.5872 20.3477 16 20.3477Z"
									fill="white"
									fill-opacity="0.98"
								/>
							</svg>
							&nbsp; Start Recording
						</button>
					</div>

					<div className="h-[600px] w-full pr-28 mt-6">
						<img
							loading="lazy"
							src={img4}
							alt="bigimg"
							className="h-full w-full rounded"
						/>
					</div>

					<div className="flex items-center mt-8">
						<svg
							className="cursor-pointer hover:opacity-80"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M32.3573 29.2381H21.8335C21.3559 29.2402 20.8825 29.148 20.4407 28.9667C19.9988 28.7854 19.5971 28.5186 19.2586 28.1816C18.9201 27.8446 18.6515 27.4441 18.4683 27.003C18.285 26.562 18.1906 26.089 18.1906 25.6114V18.3257C18.1906 17.3581 18.5739 16.4298 19.2566 15.7441C19.9393 15.0583 20.8659 14.6709 21.8335 14.6667H32.3573C33.3249 14.6709 34.2515 15.0583 34.9342 15.7441C35.6169 16.4298 36.0002 17.3581 36.0002 18.3257V25.6114C36.0002 26.089 35.9058 26.562 35.7226 27.003C35.5393 27.4441 35.2707 27.8446 34.9322 28.1816C34.5937 28.5186 34.192 28.7854 33.7502 28.9667C33.3083 29.148 32.8349 29.2402 32.3573 29.2381ZM21.8335 17.0952C21.51 17.0995 21.2011 17.231 20.9739 17.4613C20.7466 17.6916 20.6192 18.0021 20.6192 18.3257V25.6114C20.6235 25.9307 20.7533 26.2354 20.9805 26.4596C21.2078 26.6838 21.5142 26.8095 21.8335 26.8095H32.3573C32.6766 26.8095 32.983 26.6838 33.2103 26.4596C33.4375 26.2354 33.5673 25.9307 33.5716 25.6114V18.3257C33.5716 18.0021 33.4442 17.6916 33.2169 17.4613C32.9897 17.231 32.6808 17.0995 32.3573 17.0952H21.8335Z"
								fill="#555F61"
							/>
							<path
								d="M30.3335 32.8971C30.3292 33.2164 30.1994 33.5211 29.9722 33.7453C29.7449 33.9695 29.4385 34.0953 29.1192 34.0952H16.1668C15.4182 34.0952 14.7 33.799 14.1691 33.2711C13.6382 32.7432 13.3378 32.0267 13.3335 31.2781V21.5638C13.3335 21.2402 13.4609 20.9297 13.6882 20.6994C13.9154 20.4691 14.2243 20.3376 14.5478 20.3333C14.8713 20.3376 15.1801 20.4691 15.4074 20.6994C15.6347 20.9297 15.7621 21.2402 15.7621 21.5638V31.2781C15.7663 31.3826 15.8107 31.4814 15.8862 31.5539C15.9617 31.6263 16.0622 31.6667 16.1668 31.6667H29.1192C29.4427 31.6709 29.7516 31.8024 29.9788 32.0327C30.2061 32.263 30.3335 32.5736 30.3335 32.8971Z"
								fill="#555F61"
							/>
							<rect
								x="0.5"
								y="0.5"
								width="47"
								height="47"
								rx="11.5"
								stroke="#555F61"
							/>
						</svg>

						<svg
							className="cursor-pointer hover:opacity-80 ml-5"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M29.0867 16.6853C28.8747 16.4732 28.8747 16.1294 29.0867 15.9173L31.4892 13.5149C31.7012 13.3028 32.0451 13.3028 32.2571 13.5149C32.4692 13.727 32.4692 14.0708 32.2571 14.2829L29.8547 16.6853C29.6427 16.8974 29.2988 16.8974 29.0867 16.6853Z"
								fill="#555F61"
							/>
							<path
								d="M12.1724 19.9294C11.9604 20.1415 11.9604 20.4853 12.1724 20.6974C12.3845 20.9095 12.7284 20.9095 12.9404 20.6974L19.3202 14.3176C19.5322 14.1056 19.5322 13.7617 19.3202 13.5497C19.1081 13.3376 18.7642 13.3376 18.5522 13.5497L12.1724 19.9294Z"
								fill="#555F61"
							/>
							<path
								d="M12.2228 15.5783C12.0107 15.7904 12.0107 16.1342 12.2228 16.3463C12.4349 16.5584 12.7787 16.5584 12.9908 16.3463L15.0125 14.3247C15.2245 14.1126 15.2245 13.7687 15.0125 13.5567C14.8004 13.3446 14.4565 13.3446 14.2445 13.5567L12.2228 15.5783Z"
								fill="#555F61"
							/>
							<path
								d="M12.1591 25.0114C11.947 24.7993 11.947 24.4555 12.1591 24.2434L22.8179 13.5845C23.03 13.3725 23.3738 13.3725 23.5859 13.5845C23.798 13.7966 23.798 14.1405 23.5859 14.3525L12.927 25.0114C12.715 25.2235 12.3711 25.2235 12.1591 25.0114Z"
								fill="#555F61"
							/>
							<path
								d="M25.849 14.8545C25.6369 15.0666 25.6369 15.4104 25.849 15.6225C26.0611 15.8346 26.4049 15.8346 26.617 15.6225L27.9169 14.3225C28.129 14.1105 28.129 13.7666 27.9169 13.5545C27.7048 13.3425 27.361 13.3425 27.1489 13.5545L25.849 14.8545Z"
								fill="#555F61"
							/>
							<path
								d="M12.176 29.2954C11.9639 29.0833 11.9639 28.7395 12.176 28.5274L17.4346 23.2688C17.6467 23.0568 17.9905 23.0568 18.2026 23.2688C18.4146 23.4809 18.4146 23.8248 18.2026 24.0368L12.944 29.2954C12.7319 29.5075 12.3881 29.5075 12.176 29.2954Z"
								fill="#555F61"
							/>
							<path
								d="M12.1631 32.841C11.951 33.0531 11.951 33.3969 12.1631 33.609C12.3752 33.8211 12.719 33.8211 12.9311 33.609L19.0381 27.5019C19.2502 27.2899 19.2502 26.946 19.0381 26.734C18.8261 26.5219 18.4822 26.5219 18.2701 26.734L12.1631 32.841Z"
								fill="#555F61"
							/>
							<path
								d="M30.4764 18.8283C30.2643 19.0404 30.2643 19.3843 30.4764 19.5963C30.6884 19.8084 31.0323 19.8084 31.2443 19.5963L36.4063 14.4344C36.6184 14.2223 36.6184 13.8785 36.4063 13.6664C36.1942 13.4543 35.8504 13.4543 35.6383 13.6664L30.4764 18.8283Z"
								fill="#555F61"
							/>
							<path
								d="M30.4511 23.9225C30.2391 23.7104 30.2391 23.3666 30.4511 23.1545L35.6572 17.9484C35.8693 17.7364 36.2131 17.7364 36.4252 17.9484C36.6373 18.1605 36.6373 18.5043 36.4252 18.7164L31.2191 23.9225C31.007 24.1346 30.6632 24.1346 30.4511 23.9225Z"
								fill="#555F61"
							/>
							<path
								d="M30.8586 27.0478C30.6465 27.2599 30.6465 27.6037 30.8586 27.8158C31.0706 28.0279 31.4145 28.0279 31.6266 27.8158L36.4353 23.0071C36.6473 22.795 36.6473 22.4512 36.4353 22.2391C36.2232 22.027 35.8793 22.027 35.6673 22.2391L30.8586 27.0478Z"
								fill="#555F61"
							/>
							<path
								d="M32.2119 30.7633C31.9998 30.5512 31.9998 30.2074 32.2119 29.9953L35.7396 26.4676C35.9517 26.2555 36.2955 26.2555 36.5076 26.4676C36.7197 26.6796 36.7197 27.0235 36.5076 27.2355L32.9799 30.7633C32.7678 30.9754 32.4239 30.9754 32.2119 30.7633Z"
								fill="#555F61"
							/>
							<path
								d="M33.2995 32.9007C33.0875 33.1128 33.0875 33.4567 33.2995 33.6687C33.5116 33.8808 33.8554 33.8808 34.0675 33.6687L36.4505 31.2857C36.6626 31.0737 36.6626 30.7298 36.4505 30.5177C36.2385 30.3057 35.8946 30.3057 35.6825 30.5177L33.2995 32.9007Z"
								fill="#555F61"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M21.1526 18.4419C22.0064 17.5881 23.1644 17.1084 24.3719 17.1084C25.5793 17.1084 26.7373 17.5881 27.5911 18.4419C28.4449 19.2957 28.9246 20.4537 28.9246 21.6612C28.9246 22.8686 28.4449 24.0266 27.5911 24.8804C26.7373 25.7342 25.5793 26.2139 24.3719 26.2139C23.1644 26.2139 22.0064 25.7342 21.1526 24.8804C20.2988 24.0266 19.8191 22.8686 19.8191 21.6612C19.8191 20.4537 20.2988 19.2957 21.1526 18.4419ZM24.3719 18.7376C23.5965 18.7376 22.8529 19.0456 22.3046 19.5939C21.7563 20.1422 21.4483 20.8858 21.4483 21.6612C21.4483 22.4366 21.7563 23.1802 22.3046 23.7285C22.8529 24.2767 23.5965 24.5848 24.3719 24.5848C25.1472 24.5848 25.8909 24.2767 26.4391 23.7285C26.9874 23.1802 27.2954 22.4366 27.2954 21.6612C27.2954 20.8858 26.9874 20.1422 26.4391 19.5939C25.8909 19.0456 25.1472 18.7376 24.3719 18.7376Z"
								fill="#555F61"
							/>
							<path
								d="M20.7075 30.179C21.6793 29.2071 22.9975 28.6612 24.3719 28.6612C25.7463 28.6612 27.0644 29.2071 28.0363 30.179C28.8991 31.0418 29.4263 32.1775 29.5337 33.3832C29.5736 33.8313 29.9693 34.1622 30.4174 34.1223C30.8655 34.0824 31.1964 33.6867 31.1564 33.2386C31.0152 31.6538 30.3223 30.1611 29.1883 29.027C27.9109 27.7496 26.1784 27.032 24.3719 27.032C22.5654 27.032 20.8329 27.7496 19.5555 29.027C18.4214 30.1611 17.7286 31.6538 17.5873 33.2386C17.5474 33.6867 17.8783 34.0824 18.3264 34.1223C18.7745 34.1622 19.1701 33.8313 19.2101 33.3832C19.3175 32.1775 19.8447 31.0418 20.7075 30.179Z"
								fill="#555F61"
							/>
							<rect
								x="0.5"
								y="0.5"
								width="47"
								height="47"
								rx="11.5"
								stroke="#555F61"
							/>
						</svg>

						<svg
							className="cursor-pointer hover:opacity-80 ml-auto"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect
								x="0.5"
								y="0.5"
								width="47"
								height="47"
								rx="11.5"
								fill="#F38315"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M10.9916 10.9917C11.425 10.5583 12.1251 10.5583 12.5586 10.9917L21.3601 19.7932C21.3948 19.8207 21.4284 19.8504 21.4604 19.8825L27.1505 25.5726C27.1823 25.6044 27.2117 25.6376 27.2388 25.672L30.0952 28.5283C30.1788 28.5757 30.2575 28.6351 30.3289 28.7066C30.4015 28.7791 30.4622 28.8591 30.511 28.9441L37.0081 35.4413C37.4415 35.8747 37.4415 36.5748 37.0081 37.0083C36.5747 37.4417 35.8745 37.4417 35.4411 37.0083L29.4778 31.0449C28.3946 31.8946 27.1277 32.485 25.7724 32.763C25.5548 32.8076 25.3361 32.844 25.1168 32.8722V35.1078H28.4507C29.062 35.1078 29.5621 35.6079 29.5621 36.2191C29.5621 36.8303 29.062 37.3305 28.4507 37.3305H24.0239C24.0177 37.3306 24.0116 37.3306 24.0054 37.3306C23.9992 37.3306 23.9931 37.3306 23.9869 37.3305H19.56C18.9488 37.3305 18.4487 36.8415 18.4487 36.2191C18.4487 35.6079 18.9488 35.1078 19.56 35.1078H22.8941V32.8783C22.1092 32.7816 21.3355 32.5798 20.5936 32.274C18.9599 31.5961 17.5596 30.4514 16.5816 28.9733C15.6148 27.4952 15.1035 25.7615 15.1147 23.9945V21.7718C15.1147 21.1606 15.6148 20.6605 16.226 20.6605C16.8372 20.6605 17.3373 21.1606 17.3373 21.7718V24.0056C17.3262 25.3392 17.7152 26.6395 18.4487 27.7397C19.1822 28.8399 20.2379 29.7068 21.4604 30.218C22.1705 30.5123 22.9173 30.6776 23.6714 30.7142C23.7769 30.6806 23.8891 30.6625 24.0054 30.6625C24.1204 30.6625 24.2314 30.6802 24.3359 30.713C24.6714 30.6957 25.0067 30.6529 25.339 30.5847C26.2653 30.3947 27.1352 30.013 27.8964 29.4636L26.2608 27.8279C25.8341 28.0783 25.3658 28.2561 24.8723 28.351C24.5833 28.4176 24.2944 28.4399 24.0054 28.4399C23.4275 28.4399 22.8496 28.3287 22.3051 28.0954C21.4938 27.7619 20.8047 27.1952 20.3158 26.4617C19.8157 25.7393 19.56 24.8836 19.56 24.0056V21.1272L10.9916 12.5587C10.5581 12.1253 10.5581 11.4251 10.9916 10.9917ZM24.5741 26.1412L21.7943 23.3614L21.7827 23.3499V23.9945C21.7827 24.439 21.9161 24.8613 22.1606 25.2281C22.4051 25.5948 22.7496 25.8727 23.1608 26.0505C23.5609 26.2172 24.0054 26.2616 24.4388 26.1727L24.4389 26.1727C24.4809 26.1622 24.5228 26.1517 24.5741 26.1412ZM27.3394 22.1497C26.7282 22.1497 26.2281 21.6496 26.2281 21.0383V15.1038C26.2281 14.5481 26.0281 14.0258 25.6502 13.6146C25.2835 13.2034 24.7722 12.9478 24.2277 12.8922C23.6831 12.8366 23.1275 12.9811 22.6829 13.3145C22.2384 13.6368 21.9383 14.1258 21.8272 14.6592C21.7049 15.2593 21.1159 15.6483 20.5158 15.5261C19.9157 15.4038 19.5267 14.8259 19.649 14.2258C19.8712 13.1478 20.4825 12.192 21.3715 11.5363C22.2606 10.8807 23.3608 10.5806 24.4611 10.6917C25.5613 10.8029 26.5726 11.3141 27.3172 12.1365C28.0396 12.9478 28.4508 14.0035 28.4508 15.1149V21.0494C28.4508 21.6607 27.9507 22.1497 27.3394 22.1497ZM32.8961 21.7718C32.8961 21.1606 32.396 20.6605 31.7848 20.6605C31.1736 20.6605 30.6735 21.1606 30.6735 21.7718V23.9945C30.6735 24.3946 30.6401 24.7835 30.5623 25.1725C30.4512 25.7726 30.8624 26.3505 31.4625 26.4617C32.0626 26.5728 32.6405 26.1616 32.7517 25.5615C32.8517 25.0391 32.8961 24.5168 32.8961 23.9945V21.7718Z"
								fill="#F5F9FF"
								fill-opacity="0.95"
							/>
							<rect
								x="0.5"
								y="0.5"
								width="47"
								height="47"
								rx="11.5"
								stroke="#F38315"
							/>
						</svg>

						<svg
							className="cursor-pointer hover:opacity-80 ml-5"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M29.9444 22.3934V19.1667C29.9444 17.4178 28.5267 16 26.7778 16H15.1667C13.4178 16 12 17.4178 12 19.1667V29.7222C12 31.4711 13.4178 32.8889 15.1667 32.8889H26.7778C28.5267 32.8889 29.9444 31.4711 29.9444 29.7222V26.4957L35.6642 30.5813C35.986 30.8111 36.4092 30.8418 36.7608 30.6609C37.1124 30.48 37.3333 30.1177 37.3333 29.7223V19.1668C37.3333 18.7714 37.1124 18.4091 36.7608 18.2282C36.4092 18.0473 35.986 18.078 35.6642 18.3078L29.9444 22.3934ZM14.1111 19.1667C14.1111 18.5837 14.5837 18.1111 15.1667 18.1111H26.7778C27.3607 18.1111 27.8333 18.5837 27.8333 19.1667V29.7222C27.8333 30.3052 27.3607 30.7778 26.7778 30.7778H15.1667C14.5837 30.7778 14.1111 30.3052 14.1111 29.7222V19.1667ZM35.2222 27.6712L30.7049 24.4446L35.2222 21.2179V27.6712Z"
								fill="#555F61"
							/>
							<rect
								x="0.5"
								y="0.5"
								width="47"
								height="47"
								rx="11.5"
								stroke="#555F61"
							/>
						</svg>

						<svg
							className="cursor-pointer hover:opacity-80 ml-5"
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M36.5331 18.6667C36.5331 16.6416 34.8914 15 32.8664 15H15.6667C13.6416 15 12 16.6416 12 18.6667V28.8537C12 30.8788 13.6416 32.5204 15.6667 32.5204H19.7665C20.3188 32.5204 20.7665 32.0727 20.7665 31.5204C20.7665 30.9681 20.3188 30.5204 19.7665 30.5204H15.6667C14.7462 30.5204 14 29.7742 14 28.8537L14 18.6667C14 17.7462 14.7462 17 15.6667 17L32.8664 17C33.7869 17 34.5331 17.7462 34.5331 18.6667V28.8537C34.5331 29.7742 33.7869 30.5204 32.8664 30.5204H29.2665C28.7142 30.5204 28.2665 30.9681 28.2665 31.5204C28.2665 32.0727 28.7142 32.5204 29.2665 32.5204H32.8664C34.8914 32.5204 36.5331 30.8788 36.5331 28.8537V18.6667Z"
								fill="#555F61"
							/>
							<path
								d="M18.9436 25.7427C18.4618 26.2244 18.4618 27.0055 18.9436 27.4873C19.4253 27.969 20.2064 27.969 20.6882 27.4873L23.2083 24.9671V34.0853C23.2083 34.7666 23.7606 35.3189 24.4419 35.3189C25.1232 35.3189 25.6756 34.7666 25.6756 34.0853L25.6756 24.9671L28.1957 27.4873C28.6775 27.969 29.4586 27.969 29.9403 27.4873C30.4221 27.0055 30.4221 26.2244 29.9403 25.7427L25.3142 21.1166C25.0829 20.8852 24.7691 20.7552 24.4419 20.7552C24.1148 20.7552 23.801 20.8852 23.5696 21.1166L18.9436 25.7427Z"
								fill="#555F61"
							/>
							<rect
								x="0.5"
								y="0.5"
								width="47"
								height="47"
								rx="11.5"
								stroke="#555F61"
							/>
						</svg>

						<svg
							className="cursor-pointer hover:opacity-80 ml-5 mr-28"
							width="88"
							height="48"
							viewBox="0 0 88 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect width="88" height="48" rx="12" fill="#EB2F2F" />
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M33.1717 19.4681C33.2041 19.472 33.2362 19.4775 33.2681 19.4846C34.6612 19.7941 35.9072 20.5695 36.8001 21.6827C37.6931 22.7959 38.1798 24.1803 38.1798 25.6074V26.6501C38.1798 27.3814 37.8892 28.0827 37.3721 28.5998C36.855 29.1169 36.1537 29.4074 35.4224 29.4074H31.0291C30.2978 29.4074 29.5965 29.1169 29.0794 28.5998C28.5623 28.0827 28.2718 27.3814 28.2718 26.6501C28.2718 26.4492 28.192 26.2566 28.05 26.1146C27.9079 25.9725 27.7153 25.8927 27.5144 25.8927H20.4851C20.2843 25.8927 20.0916 25.9725 19.9496 26.1146C19.8076 26.2566 19.7278 26.4492 19.7278 26.6501C19.7278 27.3814 19.4373 28.0827 18.9202 28.5998C18.4031 29.1169 17.7018 29.4074 16.9705 29.4074H12.5772C11.8459 29.4074 11.1445 29.1169 10.6274 28.5998C10.1103 28.0827 9.81983 27.3814 9.81983 26.6501V25.6077M33.1717 19.4681C27.1129 18.302 20.8874 18.3008 14.8282 19.4645C14.7957 19.4684 14.7634 19.474 14.7315 19.4811C13.3376 19.7907 12.0912 20.5667 11.1981 21.6808C10.3052 22.7947 9.81899 24.1801 9.81983 25.6077M14.9613 20.4572V20.5153L15.0475 20.9033L14.9613 20.4572ZM15.1506 21.4367C14.2071 21.6498 13.3638 22.1768 12.7586 22.9317C12.1503 23.6905 11.8192 24.6342 11.8198 25.6067L11.8198 26.6501C11.8198 26.8509 11.8996 27.0436 12.0416 27.1856C12.1837 27.3276 12.3763 27.4074 12.5772 27.4074H16.9705C17.1713 27.4074 17.364 27.3276 17.506 27.1856C17.648 27.0436 17.7278 26.8509 17.7278 26.6501C17.7278 25.9188 18.0183 25.2174 18.5354 24.7003C19.0525 24.1832 19.7538 23.8927 20.4851 23.8927H27.5144C28.2457 23.8927 28.9471 24.1832 29.4642 24.7003C29.9813 25.2174 30.2718 25.9188 30.2718 26.6501C30.2718 26.8509 30.3516 27.0436 30.4936 27.1856C30.6356 27.3276 30.8282 27.4074 31.0291 27.4074H35.4224C35.6233 27.4074 35.8159 27.3276 35.9579 27.1856C36.1 27.0436 36.1798 26.8509 36.1798 26.6501V25.6074C36.1798 24.6353 35.8483 23.6924 35.2401 22.9341C34.6437 22.1907 33.8162 21.6685 32.8898 21.4497C32.8758 21.4476 32.862 21.4452 32.8482 21.4425C27.0035 20.3105 20.9961 20.3093 15.151 21.4391L15.1506 21.4367Z"
								fill="white"
								fill-opacity="0.98"
							/>
							<line
								x1="48.5"
								y1="11.5"
								x2="48.5"
								y2="36.5"
								stroke="black"
								stroke-opacity="0.2"
							/>
							<path
								d="M68 19.0031C69.1226 19.0031 70 18.1219 70 16.9969C70 15.8906 69.1038 15 68 15C66.9057 15 66 15.8906 66 16.9969C66 18.0938 66.9057 19.0031 68 19.0031ZM68 25.9781C69.1226 25.9781 70 25.1063 70 24C70 22.9031 69.1038 22.0125 68 22.0125C66.9057 22.0125 66 22.9031 66 24C66 25.0875 66.9057 25.9781 68 25.9781ZM68 33C69.1226 33 70 32.1188 70 31.0031C70 29.8875 69.1038 28.9969 68 28.9969C66.9057 28.9969 66 29.8875 66 31.0031C66 32.0906 66.9057 33 68 33Z"
								fill="white"
								fill-opacity="0.98"
							/>
						</svg>
					</div>
				</div>
			</div>
		</div>
	);
}
